export const FormTypes = {
    CG719S: 'CG-719S',
    COD: 'COD',
    SSL: 'SSL',
    NOAATOSS: 'NOAATOSS',
    ARMYTOSS: 'ARMYTOSS',
    CPR: 'CPR',
    TRAININGCERT: 'TRAININGCERT',
    NVIC: 'NVIC',
    TOAR: 'TOAR',
    SUPPORTING: 'SUPPORTING',
    USCG: {
        AOPS: 'USCGAOPS',
        TOSS: 'USCGTOSS',
    },
    TANKERMAN: 'TANKERMAN',
    GENERATE_CG719S: 'GENERATE_CG719S',
    APPLICATION_ORIGINAL: 'APPLICATION_ORIGINAL',
    APPLICATION_RENEWAL: 'APPLICATION_RENEWAL',
    APPLICATION_UPGRADE: 'APPLICATION_UPGRADE',
};

export const FormNames = {
    CG719S: 'CG 719S',
    COD: 'Certificate of Discharge',
    SSL: 'Sea Service Letter on Official Letterhead',
    NOAATOSS: 'NOAA Transcript of Sea Service',
    ARMYTOSS: 'Army Transcript of Sea Service',
    CPR: 'CPR and First Aid',
    TRAININGCERT: 'Training Certifications',
    NVIC: 'STCW NVIC',
    TOAR: 'TOAR',
    SUPPORTING: 'Supporting Documents',
    USCG: {
        AOPS: 'USCG AOPS',
        TOSS: 'USCG Transcript of Sea Service',
    },
    TANKERMAN: 'Tankerman',
    GENERATE_CG719S: 'Generate CG 719S',
    APPLICATION_ORIGINAL: 'Original Application',
    APPLICATION_RENEWAL: 'Renewal Application',
    APPLICATION_UPGRADE: 'Upgrade Application',
};

export const DocumentTypes = {
    SERVICE: [
        'cg719s',
        'cod',
        'ssl',
        'noaatoss',
        'uscgaops',
        'uscgtoss',
        'armytoss',
    ],
    TRAINING: ['trainingcert', 'cpr', 'nvic', 'toar', 'tankerman'],
    SUPPORTING: ['supporting'],
};

export const SiteUrls = {
    SEA_SERVICE_DOCS: '/documents/seaservice',
    TRAINING: '/documents/training',
    SUPPORTING_DOCS: '/documents/support',
};
